/**
 * Event Form Page
 *
 * Tenant-specific event creation form using UniversalRULForm.
 * The form endpoint is determined by the tenant subdomain.
 *
 * Route: /apps/examples/forms/event
 *
 * Tenant-specific endpoints:
 * - goldenwings: /formsexamples/forms/event/flight
 * - bellvilledental: /formsexamples/forms/event/dentist-appointment
 * - default: /formsexamples/forms/event
 */

import { useMemo } from 'react';
import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import { getTenantFromDomain } from '@/utils/tenant';
import './EventFormPage.css';

/**
 * Map tenant code to form endpoint
 */
const TENANT_FORM_ENDPOINTS: Record<string, string> = {
  GOLDENWINGS: '/formsexamples/forms/event/flight',
  BELLVILLEDENTAL: '/formsexamples/forms/event/dentist-appointment',
};

const DEFAULT_FORM_ENDPOINT = '/formsexamples/forms/event';

export const EventFormPage: React.FC = () => {
  // Determine form URL based on tenant
  const formUrl = useMemo(() => {
    const tenant = getTenantFromDomain();
    if (tenant && TENANT_FORM_ENDPOINTS[tenant]) {
      return TENANT_FORM_ENDPOINTS[tenant];
    }
    return DEFAULT_FORM_ENDPOINT;
  }, []);

  const handleSuccess = (data: any) => {
    message.success('Event created successfully!');
    console.log('Event created:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="event-form-page">
      <div className="event-form-container">
        <UniversalRULForm
          formUrl={formUrl}
          onSuccess={handleSuccess}
          onError={handleError}
          className="event-form"
        />
      </div>
    </div>
  );
};
